import a from "../../../helpers/AxiosURLSearchParams.es.js";
const e = typeof URLSearchParams < "u" ? URLSearchParams : a;
export {
  e as default
};
